import { Config } from '../../../../eliot-components/src/ConfigProvider/types';
import { MedisanteOrgReport } from '../../../Dashboard/types';
import { MedisanteDevice } from '../../../Device/types';
import { Filter } from '../../types';
import { Categories, CategoriesLabel } from './types';

export const categoriesLabels: CategoriesLabel = {
  propertyStatus: 'Flag',
  measurementType: 'Device Type',
};

export const getCategories = (devices: MedisanteDevice[], config: Config) => {
  let categories: Categories = {
    model: [],
    bloodGlucoseUnit: [],
    version: [],
    propertyStatus: [],
    ...(config.isTagsFeatureEnabled ? { tags: [] } : {}),
    ...(config.isDeviceStateFeatureEnabled ? { state: [] } : {}),
    //measurementType: [],
  };

  for (const d of devices) {
    if (
      d.bloodGlucoseUnit !== undefined &&
      categories.bloodGlucoseUnit.indexOf(d.bloodGlucoseUnit) === -1
    ) {
      categories.bloodGlucoseUnit.push(d.bloodGlucoseUnit);
    }

    if (categories.version.indexOf(d.version) === -1 && d.version !== '') {
      categories.version.push(d.version);
    }

    if (d.properties && d.properties.model) {
      d.properties.model.forEach((m) => {
        if (categories.model.indexOf(m) === -1) {
          categories.model.push(m);
        }
      });
    } else if (categories.model.indexOf(d.model) === -1) {
      categories.model.push(d.model);
    }

    if (config.isDeviceStateFeatureEnabled) {
      if (categories.state.indexOf(d.state) === -1) {
        categories.state.push(d.state);
      }
    }
    if (config.isTagsFeatureEnabled) {
      for (const t of d.tags) {
        if (categories.tags.indexOf(t) === -1) {
          categories.tags.push(t);
        }
      }
    }

    if (d.properties?.status?.length) {
      const allowedProperties: { [key: string]: string } = {
        'lost/stolen': 'Lost/Stolen',
        'faulty/damaged': 'Faulty/Damaged',
        'general/other': 'General/Other',
      };
      for (const s of d.properties?.status) {
        const prop = allowedProperties[s];
        if (categories.propertyStatus.indexOf(prop) === -1 && prop) {
          categories.propertyStatus.push(prop);
        }
      }
    }
  }
  return categories;
};

export const getCategoriesFromReport = (
  reports: MedisanteOrgReport[],
  config: Config
) => {
  let categories: Categories = {
    model: [],
    bloodGlucoseUnit: [],
    version: [],
    propertyStatus: [],
    ...(config.isTagsFeatureEnabled ? { tags: [] } : {}),
    ...(config.isDeviceStateFeatureEnabled ? { state: [] } : {}),
    measurementType: [],
  };

  const allowedProperties: { [key: string]: string } = {
    'lost/stolen': 'Lost/Stolen',
    'faulty/damaged': 'Faulty/Damaged',
    'general/other': 'General/Other',
  };

  reports.forEach((report) => {
    report.deviceVersions?.forEach((v) => {
      if (!!!categories.version.find((g) => g === v) && v !== '') {
        categories.version.push(v);
      }
    });
    report.deviceModels?.forEach((v) => {
      if (!categories.model.find((d) => d === v)) {
        categories.model.push(v);
      }
    });
    report.bloodGlucoseUnits?.forEach((v) => {
      if (!categories.bloodGlucoseUnit.find((d) => d === v)) {
        categories.bloodGlucoseUnit.push(v);
      }
    });
    report.deviceProperties?.forEach((v) => {
      const prop = allowedProperties[v];
      if (prop && !categories.propertyStatus.find((d) => d === prop)) {
        categories.propertyStatus.push(prop);
      }
    });
    report.measurementTypes?.forEach((v) => {
      if (!categories.measurementType.find((d) => d === v)) {
        categories.measurementType.push(v);
      }
    });
  });

  return categories;
};

export const hasAllFiltersMinimumLength = (value: string) =>
  value
    .replace(/ /g, ',')
    .split(',')
    .every((v) => v.length === 0 || v.length >= 4);

export const isFilterActive = (filter: Filter, filters: Filter[]) => {
  return filters.some(
    (f) => f.category === filter.category && f.value === filter.value
  );
};

export const getNoGatewayFilterWithValue = (value: boolean) => ({
  category: 'noGateway',
  value: value.toString(),
});

export const getNoSensorsFilterWithValue = (value: boolean) => ({
  category: 'noSensors',
  value: value.toString(),
});
